import React from "react";
import Proimg from "./profile.jpeg";
import { name, introone, introtwo } from "../../../data/Data";

function Aboutme() {
  return (
    <div id="about" className="text-center abt-container">
      <h1 className="project-heading">
        <button>About Me</button>
      </h1>
      <div>
        <img src={Proimg} className="img-fluid abt-img" alt="profile" />

        <h3>{name}</h3>
        <p>{introone}</p>
        <p>{introtwo}</p>
        {/* <p>
          {introthree}{" "}
          <a href="/trip" className="abt-here">
            Here
          </a>
          .
        </p> */}
      </div>
      <br />
      <br />
      <br />
    </div>
  );
}

export default Aboutme;
